import { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { motion, AnimatePresence } from "framer-motion";

const longevityTips = [
  "Practice intermittent fasting to promote cellular repair and longevity.",
  "Incorporate antioxidant-rich foods like berries and leafy greens into your diet.",
  "Engage in regular strength training to maintain muscle mass as you age.",
  "Prioritize quality sleep to support overall health and cognitive function.",
  "Practice stress-reduction techniques like meditation or deep breathing exercises.",
  "Stay socially connected to boost mental health and cognitive resilience.",
  "Challenge your brain with new learning experiences to maintain cognitive function.",
  "Maintain a consistent sleep schedule to optimize your circadian rhythm.",
  "Include omega-3 fatty acids in your diet for heart and brain health.",
  "Practice good posture to prevent joint issues and maintain mobility as you age.",
];

const LongevityTips = () => {
  const [currentTip, setCurrentTip] = useState(0);

  const nextTip = () => {
    setCurrentTip((prev) => (prev + 1) % longevityTips.length);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Longevity Tips</CardTitle>
      </CardHeader>
      <CardContent>
        <AnimatePresence mode="wait">
          <motion.div
            key={currentTip}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="min-h-[100px] flex items-center"
          >
            <p>{longevityTips[currentTip]}</p>
          </motion.div>
        </AnimatePresence>
        <Button onClick={nextTip} className="w-full mt-4">
          Next Tip
        </Button>
      </CardContent>
    </Card>
  );
};

export default LongevityTips;
